import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { setEnvironmentInjector } from './app/shared/formio-environment';
import { environment } from './environments/environment';
import './app/components/formio/date-picker/date-picker.formio';
import './app/components/formio/datetime-picker/datetime-picker.formio';
import './app/components/formio/pdf-upload/pdf-upload.formio';
import './app/components/formio/pdf-upload-multiple/pdf-upload-multiple.formio';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .then((ref) => {
        setEnvironmentInjector(ref.injector);
    })
    .catch(err => console.error(err));
